<template>
  <div>
  </div>
</template>

<script>
export default {
  created() {
    let userId = this.$route.query.userId
    let code = this.$route.query.code
    
    if(userId && code)
    {
      this.$store.dispatch('confirmarEmail',
      {
        userId,
        code
      })
    }
    else {
      this.$store.dispatch('mostrarMensaje',
      {
        imagen: 'emo-sad',
        titulo: 'Error Confirmando el Email',
        contenido: 'Los parámetros obtenidos no pertenecen a la confirmación de un email.'     
      })
    }
  }
}
</script>

